'use strict';

var LOCKED_NAV_SELECTOR = '#attributes-slot, #configurator-nav-carmodal';

var LOCKED_SECTION_SELECTOR = [
    '.product-recommendations-accessories-pack',
    '.product-recommendations-accessories',
    '.product-recommendations-accessories-membership',
    '.product-recommendations-accessories-cross-sell',
    '.configurator-specs__promotions',
    '.configurator-variation-promotions',
    '.configurator-offers',
    '.configurator-warranty-extras',
    '.interior-container'
].join(', ');

// Called from configuratorStageConfigure.init() (first paint, unconditionally on every
// configurator page) and configurator.js's product:afterAttributeSelect handler
// (re-render, already guarded by the caller). Guard here so the unconditional caller
// doesn't lock the configurator for every visitor - only changeVIN sessions.
// Don't bind a listener in here too - that double-applies the lock and stacks a
// duplicate handler on every reselect.
function lockChangeVinMode() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('action') !== 'changeVIN' || !params.get('orderId')) {
        return;
    }

    $(LOCKED_NAV_SELECTOR).addClass('disabled-configurator');

    var $allSwatches = $('#attribute-color .color-attribute');
    $allSwatches.addClass('opacity-50').css('pointer-events', 'none').attr('disabled', 'disabled');

    var $selectedSwatch = $('#attribute-color .color-attribute .color-value.selected').parent('.color-attribute');
    $selectedSwatch.removeClass('opacity-50').css('pointer-events', 'none').addClass('modify-order-ordered-value');

    $(LOCKED_SECTION_SELECTOR).css({ 'pointer-events': 'none', 'opacity': '0.5' });
}

module.exports = {
    lockChangeVinMode: lockChangeVinMode
};
